<template>
  <div class="fillcontain">
    <div class="table_container">
      <el-alert title="仅显示最后100条制作记录" type="success"></el-alert>
      <br>
      <el-table
        :data="tableData"
        style="width: 100%"
        v-loading="loading">
        <el-table-column label="主图">
          <template slot-scope="scope">
            <img :src="scope.row.orderGoods[0].goodsMainThumbnailPhoto" v-if="scope.row.orderGoods[0].goodsMainThumbnailPhoto != null" width="50" height="50"/>
          </template>
        </el-table-column>

        <el-table-column
          label="菜品"
          prop="orderGoods[0].goodsName"
        >
        </el-table-column>
        <el-table-column
          label="规格"
          prop="orderGoods[0].goodsTagItemNames"
        >
        </el-table-column>
        <el-table-column
          label="数量"
          prop="count"
        >
        </el-table-column>
        <el-table-column
          label="餐桌号"
          prop="tableNumberStr">
        </el-table-column>
        <el-table-column
          label="状态"
          prop="statusStr"
        >
        </el-table-column>
        <el-table-column
          label="备注"
          prop="note"
        >
        </el-table-column>
        <el-table-column
          label="生成时间"
          prop="createTime"
        >
        </el-table-column>


      </el-table>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      loading: false,
      tableData: [],
      pages: {}
    }
  },
  created() {

    this.initData();
  },
  methods: {
    initData() {
      this.loading = true;
      var that = this;
      that.$api.get('/store/make_order_goods_queue', this.pages, response => {
        if (response.status >= 200 && response.status < 300) {
          var res = response.data;
          if (res.code == 0) {
            that.tableData = res.data.makeOrderGoodsQueues;
          } else {
            this.$message({
              message: res.msg,
              type: 'warning'
            });
          }
        } else {
          this.$message({
            message: "服务器维护中",
            type: 'error'
          });
        }
        this.loading = false;
      });
    },
  },
}
</script>

<style lang="less">
@import '../../style/mixin';

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}

.table_container {
  padding: 20px;
  text-align: left;
}

.Pagination {
  display: flex;
  justify-content: flex-start;
  margin-top: 8px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #20a0ff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}

.avatar {
  width: 120px;
  height: 120px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/pages/store/MakeQueue.vue